module.exports = __webpack_public_path__ + "img/film-gymmen.be9865f8.jpg";